var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageOnRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 62,
    viewBox: "0 0 108 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60500",
    "data-name": "Group 60500",
    transform: "translate(-338 -251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_52831",
    "data-name": "Path 52831",
    transform: "translate(338 251)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H108V62H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 0.5 L 0.5 61.5 L 107.5 61.5 L 107.5 0.5 L 0.5 0.5 M 0 0 L 108 0 L 108 62 L 0 62 L 0 0 Z",
    stroke: "none",
    fill: "#b2b2bf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9372",
    "data-name": "Rectangle 9372",
    transform: "translate(347 259)",
    fill: "#fff",
    stroke: "#b2b2bf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 47,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 90.5,
    height: 46.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9373",
    "data-name": "Rectangle 9373",
    transform: "translate(391 259)",
    fill: "#d1d6dd",
    stroke: "#b2b2bf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 46.5,
    height: 46.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Copy_211",
    "data-name": "Rectangle Copy 211",
    transform: "translate(355.205 268.322)",
    fill: "#f1f1f5",
    stroke: "#b2b2bf",
    strokeWidth: 0.5,
    strokeDasharray: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.73,
    height: 27.861,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.23,
    height: 27.361,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-image",
    "data-name": "Icon metro-image",
    d: "M35.667,6.063l0,0V32.539l0,0H4.781l0,0V6.067l0,0Zm0-2.207H4.777A2.213,2.213,0,0,0,2.571,6.063v26.48a2.213,2.213,0,0,0,2.207,2.207H35.671a2.213,2.213,0,0,0,2.207-2.207V6.063a2.213,2.213,0,0,0-2.207-2.207Zm-4.413,7.723a3.31,3.31,0,1,1-3.31-3.31,3.31,3.31,0,0,1,3.31,3.31Zm2.207,18.757H6.984V25.923l7.723-13.24,8.827,11.033h2.207l7.723-6.62Z",
    transform: "translate(394.43 263.145)",
    fill: "#f1f1f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOnRight);
export default __webpack_public_path__ + "static/media/imageOnRight.9ba07bbab7a8a1bfb3b746e6af94963a.svg";
export { ForwardRef as ReactComponent };